import React from 'react'
import styled from 'styled-components'

import Image from '@/components/image'
import {Marquee as MarqueeUI} from '@/components/marquee'
import {edgeGradient} from '@/styles/edge-gradient'
import {BackgroundWrapper} from '@/styles/grid'
import type {ImageSource} from '@/types/image'
import type {BackgroundColor} from '@/utils/is-valid-background-color'

export interface Props {
    images: ImageSource[]
    itemWidth: number
    showOverlay?: boolean
    backgroundColor?: BackgroundColor
    speed?: number
}

export const ImagesMarquee = ({
    images,
    backgroundColor = 'default',
    showOverlay = true,
    itemWidth,
    speed,
}: Props) => (
    <BackgroundWrapper $color={backgroundColor}>
        <ImagesMarqueeWrapper
            itemWidth={itemWidth}
            speed={speed || 5}
            $showOverlay={showOverlay}
            $backgroundColor={backgroundColor}
        >
            {images.map((image, index) => (
                <StyledImage key={`${image.url}-${index}`} image={image} height={60} />
            ))}
        </ImagesMarqueeWrapper>
    </BackgroundWrapper>
)

interface ImagesMarqueeWrapperProps {
    $showOverlay: boolean
    $backgroundColor: Props['backgroundColor']
}

const ImagesMarqueeWrapper = styled(MarqueeUI)<ImagesMarqueeWrapperProps>`
    width: 100%;
    height: 60px;

    ${({$showOverlay, $backgroundColor}) => $showOverlay && edgeGradient($backgroundColor)}
`

const StyledImage = styled(Image)`
    height: 60px;
    width: 100px;
    min-width: 100px;
    object-fit: contain;
`
